var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.Visible,
          expression: "Visible",
        },
      ],
      staticClass: "modal-mask",
    },
    [
      _c("div", { staticClass: "modal-wrapper" }, [
        _c(
          "div",
          { staticClass: "modal-dialog modal-xl modal-dialog-scrollable" },
          [
            _c("div", { staticClass: "modal-content" }, [
              _c("div", { staticClass: "modal-header" }, [
                _c("h5", { staticClass: "modal-title" }, [
                  _vm._v("Add panelists"),
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "close",
                    attrs: { type: "button" },
                    on: { click: _vm.close },
                  },
                  [_vm._v("×")]
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "modal-body",
                  staticStyle: { "min-height": "300px" },
                },
                [
                  _vm.Panelists.length === 0
                    ? _c("div", [
                        _c("p", { staticClass: "lead" }, [
                          _vm._v(
                            "\n                            You currently have no Respondents set-up in the software. \n                            Please go to the "
                          ),
                          _c(
                            "a",
                            {
                              directives: [
                                {
                                  name: "sanitizedHref",
                                  rawName: "v-sanitizedHref",
                                  value: _vm.url_PeoplePage,
                                  expression: "url_PeoplePage",
                                },
                              ],
                              staticClass: "text-primary",
                            },
                            [_vm._v("People section")]
                          ),
                          _vm._v(
                            " to upload names & emails.\n                        "
                          ),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.Panelists.length > 0
                    ? _c("div", [
                        _c(
                          "nav",
                          {
                            staticClass:
                              "navbar navbar-light navbar-expand-md bg-light",
                            attrs: { role: "navigation" },
                          },
                          [
                            _c(
                              "form",
                              {
                                staticClass: "form-inline my-2 my-lg-0 ml-auto",
                                attrs: { role: "search" },
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.searchPhrase,
                                      expression: "searchPhrase",
                                    },
                                  ],
                                  staticClass:
                                    "form-control form-control-sm mr-sm-2",
                                  attrs: {
                                    type: "search",
                                    placeholder: "Search",
                                  },
                                  domProps: { value: _vm.searchPhrase },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.searchPhrase = $event.target.value
                                    },
                                  },
                                }),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "form",
                              { staticClass: "form-inline my-2 my-lg-0" },
                              [
                                _c("div", { staticClass: "dropdown" }, [
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "btn btn-sm btn-outline-secondary dropdown-toggle",
                                      attrs: {
                                        type: "button",
                                        "data-toggle": "dropdown",
                                      },
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          "Filter by: " + _vm._s(_vm.tagLabel)
                                        ),
                                      ]),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "dropdown-menu dropdown-menu-right",
                                    },
                                    [
                                      _c(
                                        "a",
                                        {
                                          staticClass: "dropdown-item",
                                          on: {
                                            click: function ($event) {
                                              return _vm.selectTag(null)
                                            },
                                          },
                                        },
                                        [_vm._v("Show all")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "h6",
                                        { staticClass: "dropdown-header" },
                                        [_vm._v("By tag:")]
                                      ),
                                      _vm._v(" "),
                                      _vm._l(_vm.Tags, function (t) {
                                        return _c(
                                          "a",
                                          {
                                            staticClass: "dropdown-item",
                                            on: {
                                              click: function ($event) {
                                                return _vm.selectTag(t)
                                              },
                                            },
                                          },
                                          [_vm._v(_vm._s(t))]
                                        )
                                      }),
                                    ],
                                    2
                                  ),
                                ]),
                              ]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("table", { staticClass: "table" }, [
                          _c(
                            "tbody",
                            _vm._l(_vm.panelistsView, function (p) {
                              return _c("tr", { key: p.ProjectUserId }, [
                                _c("td", [
                                  _c(
                                    "p",
                                    { staticClass: "fg-color-gray mb-0 mt-1" },
                                    [_c("span", [_vm._v(_vm._s(p.Name))])]
                                  ),
                                  _vm._v(" "),
                                  p.HasEmail
                                    ? _c(
                                        "small",
                                        { staticClass: "text-muted" },
                                        [_vm._v(_vm._s(p.Email))]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  !p.HasEmail
                                    ? _c(
                                        "small",
                                        { staticClass: "text-danger" },
                                        [_vm._v("Email not provided")]
                                      )
                                    : _vm._e(),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  _vm._l(p.Tags, function (t) {
                                    return _c(
                                      "span",
                                      {
                                        key: t,
                                        staticClass:
                                          "badge badge-secondary mr-1",
                                      },
                                      [_vm._v(_vm._s(t))]
                                    )
                                  }),
                                  0
                                ),
                                _vm._v(" "),
                                _vm.TargetingEnabled
                                  ? _c(
                                      "td",
                                      { staticStyle: { width: "80px" } },
                                      [
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn btn-outline-secondary",
                                            attrs: {
                                              type: "button",
                                              disabled: !p.HasEmail,
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.showPanelistAlternativesSelector(
                                                  p.ProjectUserId
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(
                                                  p.IsIncluded ? "Added" : "Add"
                                                ) +
                                                "\n                                        "
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.TargetingEnabled
                                  ? _c(
                                      "td",
                                      { staticStyle: { width: "80px" } },
                                      [
                                        p.IsIncluded
                                          ? _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn btn-outline-danger",
                                                attrs: { type: "button" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.excludePanelist(
                                                      p.ProjectUserId
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("Exclude")]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        !p.IsIncluded
                                          ? _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn btn-outline-success",
                                                attrs: { type: "button" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.includePanelist(
                                                      p.ProjectUserId
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("Include")]
                                            )
                                          : _vm._e(),
                                      ]
                                    )
                                  : _vm._e(),
                              ])
                            }),
                            0
                          ),
                        ]),
                      ])
                    : _vm._e(),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "modal-footer" }, [
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "sanitizedHref",
                        rawName: "v-sanitizedHref",
                        value: _vm.url_PeoplePage,
                        expression: "url_PeoplePage",
                      },
                    ],
                    staticClass: "btn btn-outline-secondary",
                    attrs: { target: "_blank" },
                  },
                  [_vm._v("Add people")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-outline-secondary",
                    attrs: { type: "button" },
                    on: { click: _vm.close },
                  },
                  [_vm._v("Close")]
                ),
              ]),
            ]),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }